'use strict';

var React = require('react');
var TimeSelectorTextsField$1 = require('../../DesignSystem/Inputs/DateTime/TimeSelectorTextsField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var warnedOnce = false;
var TimeSelectorTextsField = (function (props) {
  if (process.env.NODE_ENV !== 'production' && !warnedOnce) {
    console.warn(['Housecall-UI: The TimeSelectorTextsField component was moved from the library to DesignSystem.', '', "You should use `import TimeSelectorTextsField from 'housecall-ui/dist/DesignSystem/Inputs/DateTime/TimeSelectorTextsField'`"].join('\n'));
    warnedOnce = true;
  }

  return React__default["default"].createElement(TimeSelectorTextsField$1, props);
});

module.exports = TimeSelectorTextsField;
